import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="h-px w-8 bg-bb-gold/60" />
      <span className="label-eyebrow">{children}</span>
    </div>
  );
}

const STATUS_STYLES = {
  verified: "text-emerald-300 border-emerald-400/30 bg-emerald-400/10",
  Verified: "text-emerald-300 border-emerald-400/30 bg-emerald-400/10",
  "Identity-matched": "text-emerald-300 border-emerald-400/30 bg-emerald-400/10",
  "Provider-confirmed": "text-sky-300 border-sky-400/30 bg-sky-400/10",
  Reviewed: "text-sky-300 border-sky-400/30 bg-sky-400/10",
  Submitted: "text-bb-silver border-white/15 bg-white/5",
  Released: "text-emerald-300 border-emerald-400/30 bg-emerald-400/10",
  verification_pending: "text-amber-300 border-amber-400/30 bg-amber-400/10",
  Pending: "text-amber-300 border-amber-400/30 bg-amber-400/10",
  record_updated: "text-sky-300 border-sky-400/30 bg-sky-400/10",
  ownership_transfer_pending: "text-sky-300 border-sky-400/30 bg-sky-400/10",
  suspended: "text-rose-300 border-rose-400/30 bg-rose-400/10",
  revoked: "text-rose-300 border-rose-400/30 bg-rose-400/10",
  Revoked: "text-rose-300 border-rose-400/30 bg-rose-400/10",
  unable: "text-rose-300 border-rose-400/30 bg-rose-400/10",
};

export function StatusBadge({ status, label, testid }) {
  const cls = STATUS_STYLES[status] || "text-bb-silver border-white/15 bg-white/5";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1 text-xs tracking-wide ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label || status}
    </span>
  );
}
